export type Map = { [key: string]: string };

export const groups: Map = {
  ACCOUNT: 'account',
  WAREHOUSE: 'warehouse',
};

export const events: Map = {
  NAVIGATION: 'UI navigation',
  CONNECT_DWH_SUCCESSFULLY: 'Connected / Updated DWH successfully',
  CONNECT_DWH_FAILURE: 'Failed to connect / update DWH',
  CONNECT_SLACK_INTEGRATION_SUCCESSFULLY:
    'Connected / Updated Slack integration successfully',
  CONNECT_SLACK_INTEGRATION_FAILURE:
    'Failed to connect / update Slack integration',
  SET_SLACK_DEFAULT_DESTINATION_SUCCESSFULLY:
    'Set / Updated Slack default destination successfully',
  SET_TEAMS_DEFAULT_DESTINATION_SUCCESSFULLY:
    'Set / Updated MS teams default destination successfully',
  SET_TEAMS_WEBHOOKS_SUCCESSFULLY:
    'Set / Updated MS teams webhooks successfully',
  SET_SLACK_DEFAULT_DESTINATION_FAILURE:
    'Failed to set / updated Slack default destination',
  SET_TEAMS_DEFAULT_DESTINATION_FAILURE:
    'Failed to set / updated MS Teams default destination',
  SET_TEAMS_WEBHOOKS_FAILURE: 'Failed to set / updated MS Teams webhooks',
  LIST_SLACK_CHANNELS_FAILURE: 'Failed to list Slack channels',
  FETCH_TICKETING_PROJECTS_FAILURE: 'Failed to fetch ticketing projects',
  CONNECT_PAGERDUTY_INTEGRATION_SUCCESSFULLY:
    'Connected / Updated PagerDuty integration successfully',
  CONNECT_PAGERDUTY_INTEGRATION_FAILURE:
    'Failed to connect / update PagerDuty integration',
  CONNECT_OPSGENIE_INTEGRATION_SUCCESSFULLY:
    'Connected / Updated Opsgenie integration successfully',
  CONNECT_OPSGENIE_INTEGRATION_FAILURE:
    'Failed to connect / update Opsgenie integration',
  CONNECT_INCIDENT_IO_INTEGRATION_SUCCESSFULLY:
    'Connected / Updated incident.io integration successfully',
  CONNECT_INCIDENT_IO_INTEGRATION_FAILURE:
    'Failed to connect / update incident.io integration',
  CONNECT_ROOTLY_INTEGRATION_SUCCESSFULLY:
    'Connected / Updated Rootly integration successfully',
  CONNECT_ROOTLY_INTEGRATION_FAILURE:
    'Failed to connect / update Rootly integration',
  CONNECT_CODE_REPOSITORY_INTEGRATION_SUCCESSFULLY:
    'Connected / Updated code repository integration successfully',
  CONNECT_CODE_REPOSITORY_INTEGRATION_FAILURE:
    'Failed to connect / update code repository integration',
  CONNECT_BI_TOOL_INTEGRATION_SUCCESSFULLY:
    'Connected / Updated BI tool integration successfully',
  CONNECT_BI_TOOL_INTEGRATION_FAILURE:
    'Failed to connect / update BI tool integration',
  DISCONNECT_BI_TOOL_INTEGRATION_SUCCESSFULLY:
    'Disconnected BI tool successfully',
  DISCONNECT_BI_TOOL_INTEGRATION_FAILURE: 'Failed to disconnect BI tool',
  CREATE_ENVIRONMENT_SYNC_WEBHOOK_SUCCESSFULLY:
    'Created / Updated environment sync webhook successfully',
  CREATE_ENVIRONMENT_SYNC_WEBHOOK_FAILURE:
    'Failed to created / updated environment sync webhook',
  CONNECT_TICKETING_INTEGRATION_SUCCESSFULLY:
    'Connected / Updated ticketing integration successfully',
  CONNECT_TICKETING_INTEGRATION_FAILURE:
    'Failed to connect / update ticketing integration',
  DISCONNECT_TICKETING_INTEGRATION_SUCCESSFULLY:
    'Disconnected ticketing integration successfully',
  DISCONNECT_TICKETING_INTEGRATION_FAILURE:
    'Failed to disconnect ticketing integration',
  SUBMIT_TEST_FEEDBACK: 'Submit test feedback',
  SYNC_NOW_SUCCESSFULLY: 'Sync now button pressed successfully',
  SYNC_NOW_FAILURE: 'Failed to sync now',
  REQUEST_AI_ACCESS: 'Request AI access',
  AI_GENERATED_DESCRIPTION_FEEDBACK: 'AI generated description feedback',
  AI_CHAT_MESSAGE_FEEDBACK: 'AI chat message feedback',
  AI_CHAT_MESSAGE_SENT: 'AI chat message sent',
  AI_CHAT_TABLE_CSV_DOWNLOAD: 'AI chat table CSV download',
  CONNECT_DATA_CATALOG_SUCCESSFULLY:
    'Connected / Updated data catalog integration successfully',
  CONNECT_DATA_CATALOG_FAILURE: 'Failed to connect / update data catalog',
};

export const analytics: { [key: string]: Map } = {
  events,
  groups,
};
